import RelationshipMetadata from "../../RelationshipMetadata";

class WorkGroupWorkGroupUserGroupRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "WorkGroupWorkGroupUserGroupRelationshipMetadata";
        this.parentEnterpriseComponent = "WorkGroup";
        this.childEnterpriseComponent = "WorkGroupUserGroup";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default WorkGroupWorkGroupUserGroupRelationshipMetadata;